import React, { useState, useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import AppRoutes from './routes';

// Define the types
interface User {
  username: string;
}

interface Auth {
  isAuthenticated: boolean;
  user: User | null;
}

function App() {
  // Check localStorage for existing auth state
  const initialAuth = () => {
    const savedAuth = localStorage.getItem('auth');
    if (savedAuth) {
      try {
        return JSON.parse(savedAuth);
      } catch (e) {
        console.error('Error parsing auth from localStorage:', e);
        return { isAuthenticated: false, user: null };
      }
    }
    return { isAuthenticated: false, user: null };
  };

  const [auth, setAuth] = useState<Auth>(initialAuth());

  // Update localStorage when auth state changes
  useEffect(() => {
    localStorage.setItem('auth', JSON.stringify(auth));
  }, [auth]);

  const handleLogin = () => {
    const newAuth = {
      isAuthenticated: true,
      user: { username: 'admin' },
    };
    setAuth(newAuth);
    localStorage.setItem('auth', JSON.stringify(newAuth));
  };

  const handleLogout = () => {
    const newAuth = {
      isAuthenticated: false,
      user: null,
    };
    setAuth(newAuth);
    localStorage.setItem('auth', JSON.stringify(newAuth));
  };

  const routes = useRoutes(AppRoutes({ auth, handleLogin, handleLogout }));

  return <div className='app-container'>{routes}</div>;
}

export default App;
